import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './buttonGetMoreHintStyles.scss';

const countOptions = [
    { id: 1, name: "5", value: 5 },
    { id: 2, name: "10", value: 10 },
    { id: 3, name: "15", value: 15 },
    { id: 4, name: "20", value: 20 },
    { id: 5, name: "25", value: 25 },
    { id: 6, name: "30", value: 30 },
    { id: 7, name: "35", value: 35 },
    { id: 8, name: "40", value: 40 },
    { id: 9, name: "45", value: 45 },
    { id: 10, name: "50", value: 50 },
];

const ButtonGetMoreHint = ({
                               data,
                               onGetMoreHint,
                               onValueChange,
                               isActive
                           }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(5);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });

    const containerRef = useRef(null);
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);

    // Обновление позиции дропдауна
    const updateDropdownPosition = () => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width
            });
        }
    };

    // Закрытие при клике вне
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Проверяем клик по дропдауну через портал
            if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
                return;
            }

            // Проверяем клик по основному контейнеру
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        // Обновление позиции при скролле
        const handleScroll = () => {
            if (isOpen) {
                updateDropdownPosition();
            }
        };

        // Обновление позиции при ресайзе
        const handleResize = () => {
            if (isOpen) {
                updateDropdownPosition();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleScroll, true);
        window.addEventListener('resize', handleResize);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleScroll, true);
            window.removeEventListener('resize', handleResize);
        };
    }, [isOpen]);

    // Обновляем позицию при открытии
    useEffect(() => {
        if (isOpen) {
            updateDropdownPosition();
        }
    }, [isOpen]);

    const handleSelectorClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isActive) {
            setIsOpen(!isOpen);
        }
    };

    const handleOptionClick = (e, value) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedValue(value);
        setIsOpen(false);
        if (onValueChange) {
            onValueChange(value);
        }
    };

    const handleGetMoreClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isActive && onGetMoreHint) {
            onGetMoreHint(data.id, selectedValue);
        }
    };

    const selectedOption = countOptions.find(opt => opt.value === selectedValue) || countOptions[0];

    return (
        <div className="new_hitn_conteiner">
            <div className="new_hitn_count">
                Доп.подсказок: {data.count_additional_task}
            </div>
            <div
                className={`progressAndNewHint__conteiner ${isActive ? "progressAndNewHint__conteiner-active" : ""}`}
                ref={containerRef}
            >
                <button
                    className="button__add__more__hint"
                    onClick={handleGetMoreClick}
                    disabled={!isActive}
                >
                    Хочу ещё
                </button>

                <div className="custom-select-wrapper">
                    <div
                        ref={triggerRef}
                        className={`custom-select-trigger ${isOpen ? 'open' : ''} ${!isActive ? 'disabled' : ''}`}
                        onClick={handleSelectorClick}
                    >
                        <span className="selected-value">{selectedOption.name}</span>
                        <span className="arrow">▼</span>
                    </div>

                    {/* Портал для дропдауна */}
                    {isOpen && ReactDOM.createPortal(
                        <>
                            {/* Полупрозрачный фон для закрытия по клику вне (опционально) */}
                            <div
                                className="dropdown-backdrop"
                                onClick={() => setIsOpen(false)}
                            />

                            {/* Дропдаун */}
                            <div
                                ref={dropdownRef}
                                className="custom-select-dropdown portal-dropdown"
                                style={{
                                    position: 'absolute',
                                    top: dropdownPosition.top,
                                    left: dropdownPosition.left,
                                    width: dropdownPosition.width,
                                    zIndex: 9999
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {countOptions.map((option) => (
                                    <div
                                        key={option.id}
                                        className={`custom-select-option ${selectedValue === option.value ? 'selected' : ''}`}
                                        onClick={(e) => handleOptionClick(e, option.value)}
                                    >
                                        {option.name}
                                    </div>
                                ))}
                            </div>
                        </>,
                        document.body
                    )}
                </div>
            </div>
        </div>
    );
};

export default ButtonGetMoreHint;